<template>
  <div class="ui left aligned container">
    <div class="ui grid">
      <div class="ui left aligned six wide column">
        <div class="ui form">
          <div class="ui inline fields">
            <div class="inline field">
              <label>集数</label>
              <select v-model="episode">
                <option value=""></option>
                <option :value="item.episode" :key="item.episode" v-for="item in items">{{ item.name }}</option>
              </select>
            </div>
            <div class="inline field">
              <input type="checkbox" v-model="today">
              <label>只看今天</label>
            </div>
            <div class="inline field">
              <button @click="load" class="ui icon button">
                <i class="eye icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="right floated six wide column">
        <vuetable-pagination id="pagination" ref="pagination1" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div>
    </div>
    <vuetable ref="vuetable"
              :api-url="'/danmu?episode='+episode+'&today='+today"
              :fields="fields"
              :per-page="size"
              :sort-order="sortOrder"
              @vuetable:pagination-data="onPaginationData"
    >
    </vuetable>
    <div class="ui grid">
      <div class="ui left aligned six wide column">
        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
      </div>
      <div class="right floated six wide column">
        <vuetable-pagination ref="pagination2" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
      </div>
    </div>
    <Modal v-model="modal" title="状态">
      <div>
        <pre><code>{{status}}</code></pre>
      </div>
      <template slot="actions">
        <button @click="cancel" class="ui negative button" :disabled="!status.running" v-if="user.isAdmin">取消</button>
        <button @click="work" class="ui positive button" :disabled="status.running" v-if="user.isAdmin">
          工作
        </button>
      </template>
    </Modal>
  </div>
</template>
<style>
#pagination {
  margin-top: 14px;
}
</style>
<script>
import axios from 'axios'
import Vuetable from '../../table/Vuetable.vue'
import VuetablePagination from '../../table/VuetablePagination.vue'
import VuetablePaginationInfo from '../../table/VuetablePaginationInfo.vue'
import auth from "@/services/Auth";
import Modal from "@/components/Modal.vue";

export default {
  name: 'Danmu',
  components: {
    Modal,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  data() {
    return {
      fields: [
        {name: 'id', title: 'ID', sortField: 'id'},
        {name: 'content', title: '内容'},
        {name: 'score', title: '得分', sortField: 'score'},
        {name: 'upCount', title: '点赞', sortField: 'upCount'},
        {name: 'showWeight', title: '权重', sortField: 'showWeight'},
        {name: 'style', title: '样式', callback: 'style'},
        {name: 'episode', title: '集数', sortField: 'episode'},
        {name: 'timeOffset', title: '视频时间', callback: 'timeOffset'},
        {name: 'time', title: '发布时间', sortField: 'time', callback: 'date'},
      ],
      items: [],
      size: 20,
      page: 0,
      episode: '',
      today: false,
      modal: false,
      user: {},
      status: {
        running: false
      },
      sortOrder: [
        {
          field: 'id',
          direction: 'desc'
        }
      ]
    }
  },
  mounted() {
    this.items = [...Array(40)].map((_, i) => ({episode: i + 1, name: '重紫 ' + (i + 1)}))
    this.user = auth.user
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination1.setPaginationData(paginationData)
      this.$refs.pagination2.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      if (page === 'prev') {
        this.page--
      } else if (page === 'next') {
        this.page++
      } else {
        this.page = parseInt(page)
      }
      this.$refs.vuetable.changePage(page)
    },
    load() {
      axios.get('/danmu/status').then(({data}) => {
        this.modal = true
        this.status = data
      })
    },
    cancel() {
      axios.delete('/danmu').then(() => {
        this.$toasted.info('任务取消')
      })
    },
    work() {
      axios.post('/danmu').then(() => {
        this.$toasted.info('任务开始')
      })
    },
    date(value) {
      let date = new Date(value);
      return date.toLocaleString();
    },
    timeOffset(value) {
      return new Date(value).toISOString().substring(14, 19);
    },
    style(value) {
      return value ? '有' : '无'
    }
  }
}
</script>
